// require('amfe-flexible');
require('../assets/clamp/clamp');
require('../../modules/fixed_side/fixed_side')
require('../../modules/fixed_banner/fixed_banner')

import plyr from 'plyr';
import UAParser from 'ua-parser-js';
import imgReady from './utils/imgReady';
import { sendWebSiteInfo, getRequest } from './utils/sendWebsiteInfo'; // 上报统计
import {config_ph} from "./country";

if (UAParser().device.type !== 'mobile') {
  document.documentElement.classList.add('not-mobile');
}

var forEach = function (el, cb) {
  return Array.prototype.forEach.call(el, cb)
}

if (getRequest().utm_medium && getRequest().utm_medium.indexOf("baohay24h") >= 0) {
  document.getElementById("app").setAttribute("class", "lite")
}

// 文字多行截断
Array.prototype.forEach.call(
  document.querySelectorAll('[data-clamp]'),
  function (el) {
    $clamp(el, { clamp: el.getAttribute('data-clamp') });
  }
);


// 九宫格图片设置横向或竖向
Array.prototype.forEach.call(
  document.querySelectorAll('[data-direction]'),
  function (el) {
    const img = el.querySelector('img');
    const value = Number(el.getAttribute('data-direction-value')) || 1.25
    const imgUrl = img.getAttribute('src');

    imgReady(imgUrl, function () {
      if ((this.width / this.height) > value) {
        el.setAttribute('data-direction', 'horizontal');
      } else {
        el.setAttribute('data-direction', 'vertical');
      }
    })
  }
);

// 视频初始化
var player = plyr.setup('.player', {
  controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
});

// facebook分享
forEach(document.querySelectorAll('#fb-share'), function (el) {
  el.addEventListener('click', function () {
    FB.ui(
      {
        method: 'share',
        href: document
          .querySelector('[property="og:url"]')
          .getAttribute('content')
      },
      function (res) {
        console.log(res);
      }
    );
  });
});

// 文章内容显示半屏
var setHalfArticle = function () {
  var articleContent = document.querySelectorAll('.spread')
  var windowHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  );

  forEach(articleContent, function (el) {
    var article = el.previousElementSibling
    var wrap = el.parentElement
    var articleHeight = article.clientHeight
    var spread = el

    if (articleHeight > windowHeight) {
      wrap.classList.add('relative')
      article.classList.add('is-collapsed')
    }
    spread && spread.querySelector('.icon-spread').addEventListener('click', function () {
      //document.querySelector('.modal-down').classList.remove('hide');
      document.querySelector('.modal-down').classList.add('hide');
      document.querySelector('.section-content').classList.remove('is-collapsed')
    })
  })
}

var getUrlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  return results && results[1] || 0;
};

var onelinkDownload = function(downloads) {
  for (let i = 0; i < downloads.length; i++) {
    downloads[i].addEventListener('click', function () {
      let str1 = window.location.href.replace(window.location.origin+"/","");
      let str2 = str1.split(".html")[0];
      let str3 = str2.split("/").reverse();

      var content_id = str3[1];
      var doc_id = str3[0];

      var http_scheme = "https";
      if (window.location.origin.startsWith("http://")) {
        http_scheme = "http"
      }
      var onelink_path = http_scheme + `://${config_ph.product}.onelink.me/${config_ph.onelink}`;
      var article_url = http_scheme + `://news.${config_ph.product}.com/article/` + content_id + "/" + doc_id + ".html";

      var pid = getUrlParam("utm_source") || "other";
      var c = getUrlParam("shared_uid") || "0";
      var af_adset = content_id;
      var af_ad = this.getAttribute("data-pos");
      const videos = document.querySelectorAll('.video');
      const shortvideo = document.querySelectorAll('.shortvideo');
      var af_dp = config_ph.product + "://article?content_id=" + content_id + "&url=" + encodeURIComponent(article_url);
      if (shortvideo && shortvideo.length>0) {
        af_dp = config_ph.product + "://shortvideo?content_id=" + content_id + "&url=" + encodeURIComponent(article_url);
      } else if (videos && videos.length>0) {
        af_dp = config_ph.product + "://video?content_id=" + content_id + "&url=" + encodeURIComponent(article_url);
      }
      var onelink_url = onelink_path+"?pid="+pid+"&c="+c+"&af_adset="+af_adset+"&af_ad="+af_ad+"&af_dp="+encodeURIComponent(af_dp);
      window.location.href = onelink_url;
    }, false)
  }
};

document.addEventListener('DOMContentLoaded', function () {

  const version = document.getElementsByName('version')[0].getAttribute("content")

  setHalfArticle()

  sendWebSiteInfo({
    event: "view_page",
    version: version
  });

  const btns = document.getElementsByClassName('modal-close');
  for(var i = 0; i < btns.length; i += 1) {
    btns[i].addEventListener('click', function () {
      document.querySelector('.modal-down').classList.add('hide');
      document.querySelector('.section-content').classList.remove('is-collapsed')
    }, false)
  }

  const btnspos = document.querySelectorAll('[data-pos]');
  for(var i = 0; i < btnspos.length; i += 1) {
    btnspos[i].addEventListener('click', function () {
      sendWebSiteInfo({
        event: "click_download",
        pos: this.getAttribute("data-pos"),
        version: version
      })
    }, false)
  }

  const downloads1 = document.querySelectorAll('.down-now');
  onelinkDownload(downloads1);
  const downloads2 = document.querySelectorAll('.down-spread');
  onelinkDownload(downloads2);
  // new Swiper('.swiper-container', {
  //   loop: true,
  //   autoplay: {
  //     disableOnInteraction: false
  //   }
  // });
  let audioBox = document.getElementById("audioBox");
  audioBox.classList.add('hide');
});




// WEBPACK FOOTER //
// ./vn_share_ph.js